import { PLACEHOLDER_QUALITY } from '../common/constants';

export const getImageUrl = url => `${url}?fm=webp&q=${PLACEHOLDER_QUALITY}`;
